import React from "react";
import { Wordmark } from "./Logo";
import { useLang } from "../i18n";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-charcoal text-crema py-16" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div>
            <Wordmark light iconSize={30} />
            <p className="mt-5 text-crema/60 text-lg max-w-sm font-display font-medium">
              {t.footer.tagline}
            </p>
          </div>
          <div className="text-crema/50 text-sm space-y-2">
            <p>{t.footer.area}</p>
            <a href="sms:+16892666616" className="block hover:text-teal transition-colors">
              +1 (689) 266-6616
            </a>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-crema/10 text-crema/40 text-xs flex flex-col sm:flex-row justify-between gap-2">
          <span>© {year} He Meant To. {t.footer.rights}</span>
          <span>Central Florida · Orlando</span>
        </div>
      </div>
    </footer>
  );
}
